import React, {useEffect, useRef, FC} from "react";
import {useTranslation} from "next-i18next";
import {Box, Button, ButtonProps, Hidden, Typography, Card, Grid} from "@mui/material";
import {Scrollchor, ScrollchorProps} from "react-scrollchor";
import {
    EmailIcon,
    EmailShareButton,
    FacebookIcon,
    FacebookShareButton,
    PinterestIcon,
    PinterestShareButton,
    XIcon,
    TwitterShareButton,
    WhatsappIcon,
    WhatsappShareButton
} from "react-share";

import {LightningBoltCircle} from "mdi-material-ui";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";


import {Compass as CompassIcon} from "../../icons/compass";
import {DynamicDiveType} from "../../icons/dynamic-dive-type";
import {useDispatch} from "../../store";
import {styled} from "@mui/material/styles";
import {useAuth} from "../../hooks/use-auth";
import NextLink from "next-translate-routes/link";
import {useRouter} from "next-translate-routes/router";
import {InterestedDivers} from "./interested-divers";

import {setInterestedInTrip} from "../../slices/user-session-slice";
import {DiveType} from "../../types/trip";

const StyledLi = styled("li")(({theme}) => ({
    display: "inline-block",
    marginLeft: theme.spacing(1)
}))

const DetailButton = styled(Button)<ButtonProps>(({theme}) => ({
    whiteSpace: "nowrap",
    // fontSize: "30px",
    fontSize: "1.4rem",
    paddingRight: 10,
    paddingLeft: 10,
    [theme.breakpoints.up("lg")]: {
        fontSize: "1.2rem",
        paddingRight: 24,
        paddingLeft: 12
    }
}))

const SideNavLink = styled(Scrollchor)<ScrollchorProps>(({theme}) => ({
    fontWeight: 500,
    fontSize: "1.2rem",
    color: "black",
    marginTop: 8,
    marginLeft: 2,
    display: "block",
    textDecoration: "none"

}))

const navLinkKeys = [
    "photo-gallery",
    "why-we-love-it",
    "conservation",
    "who-is-it-for",
    "prices-and-dates",
    "dive-briefing",
    "visas-flights-and-more"
] as const;

type NavLinkKey = typeof navLinkKeys[number]



interface DetailPanelProps {
    tripId: string;
    title: string;
    regionName: string;
    countryName: string;
    featuredMedia: string;
    diveType: DiveType;

}


export const DetailPanel: FC<DetailPanelProps> = ({
                                                      tripId,
                                                      title,
                                                      regionName,
                                                      countryName,
                                                      featuredMedia,
                                                      diveType
                                                  }) => {


    const {locale, locales, pathname, query, route, push} = useRouter()

    const {t, i18n} = useTranslation();

    const stickyElement = useRef(null);

    const dispatch = useDispatch();

    useEffect(() => {

        if (!(typeof window === "undefined")) {
            // @ts-ignore
            stickyElement.current?.setAttribute(
                "style",
                "position: -webkit-sticky; position: sticky; top: 80px;"
            );
        }
    }, []);


    // const url = `https://www.seacrush.com/${pathname}`
    const url = `https://www.seacrush.com${window.location.pathname}`
    // console.log(`URL: ${url}`)f

    // const {isUpdatingProfile, currentProfile: {uid, interested}} = useSelector((state) => state.userSession);


    const {isAuthenticated, user} = useAuth()

    const isFavorite = user?.interested && user?.interested[tripId];

    // useEffect(() => {
    //     dispatch(fetchInterested([tripId]));
    // }, [isFavorite]);


    // const profileLoaded = isLoaded(profile);

    const handleShareClicked = (method: string) => {
        //TODO: somehow not rely on this global javascript variable

        //window.alert('test')
        // gtag("event", "share", {
        //   method: method,
        //   content_type: "trip",
        //   content_id: tripId
        // });
    };

    // const handleBookNowClicked = (event: React.MouseEvent<HTMLAnchorElement> | React.MouseEvent<HTMLButtonElement>) => {
    //     event.preventDefault();
    // };

    return (
        <div ref={stickyElement}>
            <Card
                square
                sx={{
                    p: 2
                }}>
                <Hidden mdDown>
                    <Box sx={{
                        position: "relative",
                        float: "right",
                        ml: 2,
                        width: 60,
                        height: 64
                    }}>
                        <DynamicDiveType diveType={diveType}
                                         sx={{
                                             position: "absolute",
                                             top: `50%`,
                                             left: `50%`,
                                             transform: "translate(-50%, -50%)",
                                             height: 56
                                         }}
                                         />
                    </Box>
                </Hidden>
                <Box sx={{
                    overflowX: "hidden",
                    backgroundColor: "#F6F6F6",
                    border: "1px solid #1e1e1e",
                    borderRadius: "2px",
                    p: 1
                }}>
                    <Grid container alignItems={"center"}>
                        <Hidden mdDown>
                            <Grid item>
                                <CompassIcon width={40} height={40} sx={{
                                    paddingTop: "6px",
                                    fontSize: 52,
                                    float: "left",
                                    marginRight: 1,
                                }}/>
                            </Grid>
                        </Hidden>
                        <Grid item>
                            <Typography sx={{
                                fontFamily: "Neutra Text TF",
                                whiteSpace: "nowrap",
                                mt: "2px"
                            }} variant={"body1"}>
                                <div style={{textTransform: "uppercase"}}>{regionName}</div>
                                <div style={{textTransform: "lowercase"}}>{countryName}</div>
                            </Typography>
                        </Grid>
                    </Grid>
                </Box>
                <nav style={{marginTop: 12}}>
                    {navLinkKeys.map((text, idx) => {

                        return <SideNavLink key={text} to={`#${text}`} aria-label={t(text)}>
                            {t(text)}
                        </SideNavLink>
                    })}
                </nav>
                <hr style={{borderTopWidth: 1, marginTop: 12}}/>
                <ul style={{marginTop: 12, padding: 0, display: "block"}}>
                    <StyledLi
                        style={{paddingLeft: 0, float: "left"}}
                    >
                        <div style={{height: 32}}>
                            <Hidden mdDown>
                <span
                    style={{
                        display: "inline-block",
                        verticalAlign: "middle",
                        paddingTop: 6
                    }}
                >
                  {t("share")}{" "}
                </span>
                            </Hidden>
                        </div>
                    </StyledLi>
                    <StyledLi>
                        <FacebookShareButton
                            style={{cursor: "pointer"}}
                            beforeOnClick={() => handleShareClicked("Facebook")}
                            url={url}
                        >
                            <FacebookIcon size={32}/>
                        </FacebookShareButton>
                    </StyledLi>
                    <Hidden lgDown>
                        <StyledLi>
                            <TwitterShareButton
                                style={{cursor: "pointer"}}
                                beforeOnClick={() => handleShareClicked("Twitter")}
                                url={url}
                                title={title}
                                hashtags={["SeaCrush"]}
                            >
                                <XIcon size={32}/>
                            </TwitterShareButton>
                        </StyledLi>
                    </Hidden>
                    <Hidden mdDown>
                        <StyledLi>
                            <WhatsappShareButton
                                style={{cursor: "pointer"}}
                                beforeOnClick={() => handleShareClicked("WhatsApp")}
                                url={url}
                                title={title}
                                separator={" "}
                            >
                                <WhatsappIcon size={32}/>
                            </WhatsappShareButton>
                        </StyledLi>
                    </Hidden>
                    <StyledLi>
                        <PinterestShareButton
                            style={{cursor: "pointer"}}
                            beforeOnClick={() => handleShareClicked("Pinterest")}
                            url={url}
                            media={featuredMedia}
                            description={title}
                        >
                            <PinterestIcon size={32}/>
                        </PinterestShareButton>
                    </StyledLi>
                    <StyledLi>
                        <EmailShareButton
                            style={{cursor: "pointer"}}
                            beforeOnClick={() => handleShareClicked("Email")}
                            body={"\n"}
                            subject={"SeaCrush: " + title}
                            url={url}
                        >
                            <EmailIcon size={32}/>
                        </EmailShareButton>
                    </StyledLi>
                </ul>
                {isFavorite ? (
                    <NextLink href={{
                        pathname: "/request-booking",
                        query: {
                            tripIdEnc: window.btoa(tripId)
                        }
                    }} passHref legacyBehavior>
                        <DetailButton
                            variant='contained'
                            color='secondary'
                            fullWidth

                        >
                            <Hidden mdDown>
                                <LightningBoltCircle sx={{mr:1, verticalAlign: "text-bottom"}}/>
                            </Hidden>
                            {t("book-now-button")}
                        </DetailButton>
                    </NextLink>
                ) : (
                    <DetailButton
                        variant='contained'
                        color='primary'
                        fullWidth
                        disabled={!isAuthenticated}
                        onClick={async e => {
                            if (user) dispatch(setInterestedInTrip(user, tripId))
                        }}
                    >
                        <Hidden mdDown>
                            <FavoriteBorderIcon  sx={{mr:1, verticalAlign: "text-bottom"}}/>
                        </Hidden>
                        {t("im-interested")}
                    </DetailButton>
                )}
            </Card>

            <InterestedDivers tripId={tripId}/>
        </div>
    );
}

